export mascote from "./mascote.png";



// WEBPACK FOOTER //
// ./src/components/app/not-found/images/index.js